import React from "react";
import Page from "../../../common/components/Page";
import useRegister from "./useRegister";
import Registration from "./Registration";
import FinalRegistration from "./FinalRegistration";

const Register = () => {
  const { registerForm, finalRegisterForm, isRegisterLoading, isValidated, handleRegisterClick, handleFinalRegisterClick, handleOnCancelClick } = useRegister();

  return (
    <Page>
      <Page.Title icon="user" title="Account Registration" />
      <Page.Content>
        {isValidated ? (
          <FinalRegistration finalRegisterForm={finalRegisterForm} handleFinalRegisterClick={handleFinalRegisterClick} handleOnCancelClick={handleOnCancelClick} />
        ) : (
          <Registration registerForm={registerForm} isRegisterLoading={isRegisterLoading} handleRegisterClick={handleRegisterClick} handleOnCancelClick={handleOnCancelClick} />
        )}
      </Page.Content>
    </Page>
  );
};

export default Register;
